import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "topbar" }
const _hoisted_3 = { class: "topbar__left" }
const _hoisted_4 = { class: "topbar__logo" }
const _hoisted_5 = { class: "topbar__right" }
const _hoisted_6 = { class: "runstate__text" }
const _hoisted_7 = { class: "panel flow" }
const _hoisted_8 = { class: "flow__track" }
const _hoisted_9 = { class: "step__icon" }
const _hoisted_10 = { class: "step__text" }
const _hoisted_11 = { class: "step__name" }
const _hoisted_12 = { class: "step__desc" }
const _hoisted_13 = {
  key: 0,
  class: "flow__line"
}
const _hoisted_14 = { class: "metrics" }
const _hoisted_15 = { class: "metric" }
const _hoisted_16 = { class: "metric__icon metric__icon--green" }
const _hoisted_17 = { class: "metric__body" }
const _hoisted_18 = { class: "metric__value" }
const _hoisted_19 = { class: "metric" }
const _hoisted_20 = { class: "metric__icon metric__icon--blue" }
const _hoisted_21 = { class: "metric__body" }
const _hoisted_22 = { class: "metric__value" }
const _hoisted_23 = { class: "metric" }
const _hoisted_24 = { class: "metric__icon metric__icon--amber" }
const _hoisted_25 = { class: "metric__body" }
const _hoisted_26 = { class: "metric__value" }
const _hoisted_27 = { class: "metric__foot" }
const _hoisted_28 = { class: "metric" }
const _hoisted_29 = { class: "metric__icon metric__icon--violet" }
const _hoisted_30 = { class: "metric__body" }
const _hoisted_31 = { class: "metric__value" }
const _hoisted_32 = { class: "cols" }
const _hoisted_33 = { class: "panel" }
const _hoisted_34 = { class: "params" }
const _hoisted_35 = { class: "param__top" }
const _hoisted_36 = { class: "param__title" }
const _hoisted_37 = {
  key: 0,
  class: "param__tag"
}
const _hoisted_38 = { class: "param__hint" }
const _hoisted_39 = { class: "param__ctrl" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "panel" }
const _hoisted_42 = { class: "panel__head" }
const _hoisted_43 = { class: "badge badge--violet" }
const _hoisted_44 = { class: "restore__actions" }
const _hoisted_45 = {
  key: 0,
  class: "notice notice--bad"
}
const _hoisted_46 = {
  key: 1,
  class: "notice notice--ok"
}
const _hoisted_47 = {
  key: 2,
  class: "notice"
}
const _hoisted_48 = { class: "panel" }
const _hoisted_49 = { class: "tab-label" }
const _hoisted_50 = { class: "list" }
const _hoisted_51 = { class: "job__head" }
const _hoisted_52 = { class: "job__month" }
const _hoisted_53 = { class: "job__trigger" }
const _hoisted_54 = { class: "job__time" }
const _hoisted_55 = { class: "job__body" }
const _hoisted_56 = { class: "job__meta" }
const _hoisted_57 = { class: "job__meta" }
const _hoisted_58 = { class: "job__meta" }
const _hoisted_59 = ["title"]
const _hoisted_60 = {
  key: 0,
  class: "empty"
}
const _hoisted_61 = { class: "tab-label" }
const _hoisted_62 = { class: "toolbar" }
const _hoisted_63 = {
  key: 0,
  class: "tablewrap"
}
const _hoisted_64 = { class: "reg" }
const _hoisted_65 = { class: "mono" }
const _hoisted_66 = { class: "num" }
const _hoisted_67 = { class: "num" }
const _hoisted_68 = ["title"]
const _hoisted_69 = { class: "dim tcell" }
const _hoisted_70 = {
  key: 1,
  class: "empty"
}

import { computed, onMounted, onUnmounted, ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  Calendar,
  CircleCheck,
  CircleCheckFilled,
  Clock,
  Cpu,
  Delete,
  Document,
  Download,
  Files,
  Folder,
  InfoFilled,
  RefreshLeft,
  Search,
  Tickets,
  Timer,
  VideoPlay,
  WarningFilled,
} from "@element-plus/icons-vue";
import {
  getArchiveStatusApi,
  runArchiveApi,
  getArchiveRegistryApi,
  updateArchiveConfigApi,
  getArchiveRestoreOptionsApi,
  startArchiveRestoreApi,
  getArchiveRestoreStatusApi,
  type ArchiveRegistryRow,
  type ArchiveStatus,
  type RestoreState,
} from "@/api/archiveApi";

// ===== 状态 =====

export default /*@__PURE__*/_defineComponent({
  __name: 'ArchiveManagementView',
  setup(__props) {

const status = ref<ArchiveStatus | null>(null);
const registryRows = ref<ArchiveRegistryRow[]>([]);
const registryMonth = ref<string>("");
const running = ref(false);
const activeTab = ref("jobs");

// ===== 数据恢复状态 =====
const restoreOptions = ref<ArchiveRegistryRow[]>([]);
const restoreSelected = ref<string>("");
const restoreState = ref<RestoreState | null>(null);
const restoring = ref(false);
let restorePollTimer: number | undefined;

// ===== 轮询（任务运行时 5s，空闲 30s）=====
let pollTimer: number | undefined;

const refreshStatus = async () => {
  status.value = await getArchiveStatusApi();
};

const startPolling = () => {
  stopPolling();
  const tick = async () => {
    await refreshStatus();
    pollTimer = window.setTimeout(tick, status.value?.running ? 5000 : 30000);
  };
  pollTimer = window.setTimeout(tick, 1000);
};

const stopPolling = () => {
  if (pollTimer) {
    clearTimeout(pollTimer);
    pollTimer = undefined;
  }
};

onMounted(() => {
  startPolling();
  loadRegistry();
  loadRestoreOptions();
  refreshRestoreStatus();
});
onUnmounted(() => {
  stopPolling();
  stopRestorePolling();
});

// ===== 数据流水线（随四个运行参数实时点亮）=====
const pipelineSteps = computed(() => {
  const exportOn = !!status.value?.exportEnabled;
  const deleteOn = !!status.value?.deleteEnabled;
  return [
    {
      key: "ingest",
      name: "终端上报",
      desc: "1 秒/条照常入库",
      on: true,
      tone: "blue",
      icon: Cpu,
    },
    {
      key: "export",
      name: "导出 Parquet",
      desc: exportOn ? "已开启 · 整月导出" : "未开启 · 只留库内",
      on: exportOn,
      tone: "blue",
      icon: Download,
    },
    {
      key: "verify",
      name: "行数核对",
      desc: exportOn ? "一致才继续" : "随导出进行",
      on: exportOn,
      tone: "blue",
      icon: CircleCheck,
    },
    {
      key: "delete",
      name: "删除库内明细",
      desc: deleteOn ? "已开启 · 核对后删库" : "未开启 · 库内留存",
      on: deleteOn,
      tone: "red",
      icon: Delete,
    },
    {
      key: "file",
      name: "文件永久保留",
      desc: "永不删除 · 可查询可恢复",
      on: true,
      tone: "green",
      icon: Folder,
    },
  ];
});

// ===== 运行参数（卡片化渲染）=====
const paramItems = computed(() => [
  {
    key: "export",
    name: "归档导出",
    icon: Download,
    tone: "blue",
    hint: "关闭后任务完全不动，数据只留库内（安全方向）",
    on: !!status.value?.exportEnabled,
    toggle: (v: string | number | boolean) =>
      updateConfig("archive.export.enabled", String(v)),
  },
  {
    key: "delete",
    name: "归档删除",
    icon: Delete,
    tone: "red",
    tag: "高危",
    hint: "仅在「导出 + 核对 + 登记」全部成功后才会删库数据",
    on: !!status.value?.deleteEnabled,
    toggle: (v: string | number | boolean) =>
      updateConfig("archive.delete.enabled", String(v)),
  },
  {
    key: "query",
    name: "归档查询",
    icon: Search,
    tone: "violet",
    hint: "开：归档月查文件（5 分钟粒度）；关：全部查数据库",
    on: !!status.value?.queryEnabled,
    toggle: (v: string | number | boolean) =>
      updateConfig("archive.query.enabled", String(v)),
  },
  {
    key: "retention",
    name: "保留期 N",
    icon: Calendar,
    tone: "green",
    hint: "保留最近 N 个完整自然月 + 当月，更早的整月归档",
    on: status.value?.retentionMonths ?? 1,
    chips: [1, 3, 6, 12],
    toggle: (n: number) => updateConfig("archive.retention.months", String(n)),
  },
]);

// ===== 指标（从登记台账聚合）=====
const statArchivedMonths = computed(
  () =>
    new Set(
      registryRows.value
        .filter((r) => r.monthState === "ARCHIVED")
        .map((r) => r.month)
    ).size
);
const statTotalSize = computed(() =>
  formatSize(registryRows.value.reduce((s, r) => s + (r.fileSize ?? 0), 0))
);
/** 待删除源数（已导出未删除）；删除开关开启时会被下次任务删掉 */
const statPendingSources = computed(
  () => registryRows.value.filter((r) => r.sourceState === "EXPORTED").length
);

// ===== 数据恢复 =====
const loadRestoreOptions = async () => {
  restoreOptions.value = (await getArchiveRestoreOptionsApi()) ?? [];
};

const refreshRestoreStatus = async () => {
  const st = await getArchiveRestoreStatusApi();
  if (st) {
    restoreState.value = st;
    restoring.value = st.running;
    if (!st.running) {
      stopRestorePolling();
      if (st.tableName) {
        loadRegistry();
        loadRestoreOptions();
        refreshStatus();
      }
    }
  }
};

const startRestorePolling = () => {
  stopRestorePolling();
  const tick = async () => {
    await refreshRestoreStatus();
    if (restoring.value) {
      restorePollTimer = window.setTimeout(tick, 3000);
    }
  };
  restorePollTimer = window.setTimeout(tick, 2000);
};

const stopRestorePolling = () => {
  if (restorePollTimer) {
    clearTimeout(restorePollTimer);
    restorePollTimer = undefined;
  }
};

const restoreDbLabel = (tableName: string) =>
  tableName.startsWith("deviceReport_") ? "MongoDB" : "ClickHouse";

const startRestore = async () => {
  const row = restoreOptions.value.find(
    (r) => `${r.tableName}|${r.month?.slice(0, 7)}` === restoreSelected.value
  );
  if (!row || !row.month) {
    ElMessage.warning("请先选择要恢复的源和月份");
    return;
  }
  const month = row.month.slice(0, 7);
  const deleteOn = status.value?.deleteEnabled;
  const queryOn = status.value?.queryEnabled;
  try {
    await ElMessageBox.confirm(
      `将把【${restoreDbLabel(row.tableName)}】${
        row.tableName
      } 的 ${month} 数据` +
        `（${row.rowCount.toLocaleString()} 行）从归档文件写回数据库。\n\n` +
        (deleteOn
          ? "⚠️ 当前删除开关为【开启】：下次归档任务执行时（每月 1 号自动或手动触发）会再次删除该月数据（文件永久保留）。如需数据留库使用一段时间，请先关闭删除开关。\n\n"
          : "当前删除开关为【关闭】：数据会一直留库；待开启删除开关后，下次归档任务会将该月数据再次删除（文件永久保留）。\n\n") +
        (queryOn
          ? "📌 当前查询路由开关为【开启】：用户端查该月曲线仍走归档文件（5 分钟粒度）。要在页面查看恢复的逐秒明细，请关闭「归档查询」开关。"
          : "当前查询路由开关为【关闭】：页面查询全部走数据库，可直接查看恢复的逐秒明细。"),
      "高危操作确认",
      {
        type: "warning",
        confirmButtonText: "我已知晓，确认恢复",
        cancelButtonText: "取消",
      }
    );
  } catch {
    return; // 用户取消
  }
  const res = await startArchiveRestoreApi(row.tableName, month);
  if (res?.started) {
    ElMessage.success("恢复已启动，正在执行…");
    restoring.value = true;
    startRestorePolling();
  } else {
    ElMessage.error(res?.error || "启动失败");
  }
};

// ===== 操作 =====
const runNow = async () => {
  if (status.value?.running) {
    ElMessage.info("任务正在运行中，页面每 5 秒自动刷新");
    return;
  }
  running.value = true;
  try {
    const ok = await runArchiveApi();
    if (ok) {
      ElMessage.success("已触发");
      setTimeout(refreshStatus, 1000);
    } else {
      ElMessage.warning("触发失败，请查看后端日志");
    }
  } finally {
    running.value = false;
  }
};

const updateConfig = async (key: string, value: string) => {
  if (key === "archive.delete.enabled" && value === "true") {
    ElMessage.warning("删除开关已开启：请确认灰度验证（文件抽查）已完成");
  }
  const ok = await updateArchiveConfigApi(key, value);
  if (ok) {
    ElMessage.success("参数已生效");
    refreshStatus();
  } else {
    ElMessage.error("修改失败");
  }
};

const loadRegistry = async () => {
  registryRows.value =
    (await getArchiveRegistryApi(registryMonth.value || undefined)) ?? [];
};

// ===== 格式化 / 状态映射 =====
const formatSize = (bytes: number): string => {
  if (!bytes) return "-";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024)
    return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
};

const statusText = (s: string) =>
  ({ RUNNING: "运行中", SUCCESS: "成功", PARTIAL: "部分失败", FAILED: "失败" }[
    s
  ] ?? s);

const monthStateText = (s: string) =>
  ({
    EXPORTING: "导出中",
    ALL_EXPORTED: "待删除",
    ARCHIVED: "已归档",
    FAILED: "失败",
    PARTIAL: "部分失败",
  }[s] ?? s);
const monthPill = (s: string) =>
  ({
    EXPORTING: "warning",
    ALL_EXPORTED: "blue",
    ARCHIVED: "success",
    FAILED: "danger",
    PARTIAL: "warning",
  }[s] ?? "gray");

const sourceStateText = (s: string) =>
  ({ PENDING: "未处理", EXPORTED: "已导出", ARCHIVED: "已删除" }[s] ?? s);
const sourcePill = (s: string) =>
  ({ PENDING: "gray", EXPORTED: "amber", ARCHIVED: "success" }[s] ?? "gray");

/** 登记明细月份 chip 配色（与月批次状态对应） */
const monthChip = (s: string) =>
  ({
    EXPORTING: "pending",
    ALL_EXPORTED: "waiting",
    ARCHIVED: "done",
    FAILED: "bad",
    PARTIAL: "waiting",
  }[s] ?? "idle");

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Folder))
            ]),
            _: 1
          })
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "topbar__title" }, "归档管理"),
          _createElementVNode("p", { class: "topbar__sub" }, " 数据库只留最近 N 个完整月 · 更早的整月导出 Parquet 永久保存 · 核对一致才删库 ")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["runstate", { 'runstate--live': status.value?.running }])
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "runstate__dot" }, null, -1)),
          _createElementVNode("span", _hoisted_6, _toDisplayString(status.value?.running
              ? "任务执行中 · 5s 自动刷新"
              : "空闲 · 每月 1 号 02:00 自动执行"), 1)
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["runbtn", { 'runbtn--live': status.value?.running }]),
          onClick: runNow
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(VideoPlay))
            ]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(status.value?.running ? "执行中…" : "立即执行"), 1)
        ], 2)
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "panel__head" }, [
        _createElementVNode("span", { class: "panel__title" }, "数据流水线"),
        _createElementVNode("span", { class: "panel__desc" }, "数据从上报到永久保存的完整去向（随运行参数实时变化）")
      ], -1)),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pipelineSteps.value, (step, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: step.key
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["step", step.on ? `step--on-${step.tone}` : 'step--off'])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(step.icon)))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(step.name), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(step.desc), 1)
              ])
            ], 2),
            (i < pipelineSteps.value.length - 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Folder))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(statTotalSize.value), 1),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "metric__label" }, "归档文件总量", -1))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "metric__foot" }, "永久保存 · 可查询可恢复", -1))
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Tickets))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, _toDisplayString(statArchivedMonths.value), 1),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "metric__label" }, "已归档月份", -1))
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "metric__foot" }, "整月完成导出并删库", -1))
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Timer))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, _toDisplayString(statPendingSources.value), 1),
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "metric__label" }, "待删除源", -1))
        ]),
        _createElementVNode("div", _hoisted_27, _toDisplayString(status.value?.deleteEnabled ? "下次任务将删除" : "删除开关未开启"), 1)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Clock))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, _toDisplayString(status.value?.retentionMonths ?? "-"), 1),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "metric__label" }, "保留期 N（月）", -1))
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "metric__foot" }, "更早的月份整月归档", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("section", _hoisted_33, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "panel__head" }, [
          _createElementVNode("span", { class: "panel__title" }, "运行参数"),
          _createElementVNode("span", { class: "panel__desc" }, "修改立即生效 · 灰度路径：先导出 → 再查询 → 最后删除")
        ], -1)),
        _createElementVNode("div", _hoisted_34, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paramItems.value, (p) => {
            return (_openBlock(), _createElementBlock("div", {
              key: p.key,
              class: _normalizeClass(["param", `param--${p.tone}`])
            }, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", {
                  class: _normalizeClass(["param__icon", `param__icon--${p.tone}`])
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(p.icon)))
                    ]),
                    _: 2
                  }, 1024)
                ], 2),
                _createElementVNode("div", _hoisted_36, [
                  _createTextVNode(_toDisplayString(p.name) + " ", 1),
                  (p.tag)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(p.tag), 1))
                    : _createCommentVNode("", true)
                ]),
                (!p.chips)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["param__state", 
                  p.on ? `param__state--on-${p.tone}` : 'param__state--off'
                ])
                    }, _toDisplayString(p.on ? "已开启" : "已关闭"), 3))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_38, _toDisplayString(p.hint), 1),
              _createElementVNode("div", _hoisted_39, [
                (p.chips)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(p.chips, (n) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: n,
                        class: _normalizeClass(["chip", { 'chip--on': p.on === n }]),
                        onClick: ($event: any) => (p.toggle(n))
                      }, _toDisplayString(n) + " 月 ", 11, _hoisted_40))
                    }), 128))
                  : (_openBlock(), _createBlock(_component_el_switch, {
                      key: 1,
                      "model-value": !!p.on,
                      onChange: (v) => p.toggle(v)
                    }, null, 8, ["model-value", "onChange"]))
              ])
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "panel__title" }, "数据恢复", -1)),
          _createElementVNode("span", _hoisted_43, _toDisplayString(restoreOptions.value.length) + " 个源可恢复", 1)
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("p", { class: "panel__note" }, [
          _createTextVNode(" 把已删除的归档月从文件写回数据库（临时回库核对用）。删除开关开启时，下次归档任务会再次删除该月；"),
          _createElementVNode("b", null, "文件永久保留"),
          _createTextVNode("，可反复恢复。 ")
        ], -1)),
        _createVNode(_component_el_select, {
          modelValue: restoreSelected.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((restoreSelected).value = $event)),
          class: "restore__select",
          placeholder: "选择：库 · 表/集合 · 月份 · 行数",
          disabled: restoring.value
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(restoreOptions.value, (r) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: r.id,
                value: `${r.tableName}|${r.month?.slice(0, 7)}`,
                label: `【${restoreDbLabel(r.tableName)}】${
              r.tableName
            } — ${r.month?.slice(0, 7)}（${r.rowCount.toLocaleString()} 行）`
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _createElementVNode("div", _hoisted_44, [
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: restoring.value || !restoreSelected.value,
            loading: restoring.value,
            onClick: startRestore
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(RefreshLeft))
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(restoring.value ? "恢复中…" : "开始恢复"), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_el_button, {
            text: "",
            disabled: restoring.value,
            onClick: loadRestoreOptions
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createTextVNode(" 刷新清单 ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ]),
        (restoreState.value?.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(WarningFilled))
                ]),
                _: 1
              }),
              _createElementVNode("div", null, "恢复失败：" + _toDisplayString(restoreState.value.error), 1)
            ]))
          : (restoreState.value?.tableName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CircleCheckFilled))
                  ]),
                  _: 1
                }),
                _createElementVNode("div", null, _toDisplayString(restoreState.value.tableName) + " · " + _toDisplayString(restoreState.value.month) + " · " + _toDisplayString(restoreState.value.message), 1)
              ]))
            : (!restoreOptions.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(InfoFilled))
                    ]),
                    _: 1
                  }),
                  _cache[16] || (_cache[16] = _createElementVNode("div", null, "暂无可恢复数据（没有已删除状态的源月）", -1))
                ]))
              : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("section", _hoisted_48, [
      _createVNode(_component_el_tabs, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTab).value = $event)),
        class: "tabs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, { name: "jobs" }, {
            label: _withCtx(() => [
              _createElementVNode("span", _hoisted_49, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Document))
                  ]),
                  _: 1
                }),
                _cache[18] || (_cache[18] = _createTextVNode("执行记录", -1))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_50, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.value?.recentJobs ?? [], (job) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: job.id,
                    class: _normalizeClass(["job", `job--${job.status.toLowerCase()}`])
                  }, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["pill", 'pill--' + job.status.toLowerCase()])
                      }, _toDisplayString(statusText(job.status)), 3),
                      _createElementVNode("span", _hoisted_52, _toDisplayString(job.targetMonth?.slice(0, 7)), 1),
                      _createElementVNode("span", _hoisted_53, _toDisplayString(job.triggerType === "MANUAL"
                      ? "手动触发"
                      : job.triggerType === "RESTORE"
                      ? "数据恢复"
                      : "定时触发"), 1),
                      _createElementVNode("span", _hoisted_54, [
                        _createTextVNode(_toDisplayString(job.startTime?.replace("T", " ").slice(0, 19)) + " ", 1),
                        (job.endTime)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" → " + _toDisplayString(job.endTime?.replace("T", " ").slice(11, 19)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("span", _hoisted_56, " 源 " + _toDisplayString(job.okSources) + "/" + _toDisplayString(job.totalSources), 1),
                      _createElementVNode("span", _hoisted_57, _toDisplayString(job.rowCount.toLocaleString()) + " 行", 1),
                      _createElementVNode("span", _hoisted_58, _toDisplayString(formatSize(job.fileBytes)), 1),
                      (job.errorSummary)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "job__error",
                            title: job.errorSummary
                          }, _toDisplayString(job.errorSummary), 9, _hoisted_59))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128)),
                (!status.value?.recentJobs?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Document))
                        ]),
                        _: 1
                      }),
                      _cache[19] || (_cache[19] = _createElementVNode("div", null, "暂无执行记录，点右上角「立即执行」开始", -1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, { name: "registry" }, {
            label: _withCtx(() => [
              _createElementVNode("span", _hoisted_61, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Files))
                  ]),
                  _: 1
                }),
                _cache[20] || (_cache[20] = _createTextVNode("登记明细", -1))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_component_el_date_picker, {
                  modelValue: registryMonth.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((registryMonth).value = $event)),
                  type: "month",
                  "value-format": "YYYY-MM",
                  placeholder: "全部月份",
                  clearable: "",
                  size: "small",
                  style: {"width":"150px"}
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: loadRegistry
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("查询", -1)
                  ]))]),
                  _: 1
                }),
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "toolbar__hint" }, "每源每月一行 · 归档数据的权威台账", -1))
              ]),
              (registryRows.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("table", _hoisted_64, [
                      _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "月份"),
                          _createElementVNode("th", null, "源表 / 船集合"),
                          _createElementVNode("th", { class: "num" }, "行数"),
                          _createElementVNode("th", { class: "num" }, "文件大小"),
                          _createElementVNode("th", null, "月批次"),
                          _createElementVNode("th", null, "源状态"),
                          _createElementVNode("th", null, "归档目录"),
                          _createElementVNode("th", null, "导出 / 删除时间")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(registryRows.value, (row) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: row.id
                          }, [
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["monthchip", 'monthchip--' + monthChip(row.monthState)])
                              }, _toDisplayString(row.month?.slice(0, 7)), 3)
                            ]),
                            _createElementVNode("td", _hoisted_65, _toDisplayString(row.tableName), 1),
                            _createElementVNode("td", _hoisted_66, _toDisplayString(row.rowCount.toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_67, _toDisplayString(formatSize(row.fileSize)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["pill pill--plain", 'pill--' + monthPill(row.monthState)])
                              }, _toDisplayString(monthStateText(row.monthState)), 3)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["pill pill--plain", 'pill--' + sourcePill(row.sourceState)])
                              }, _toDisplayString(sourceStateText(row.sourceState)), 3)
                            ]),
                            _createElementVNode("td", {
                              class: "mono dim ellipsis",
                              title: row.filePath
                            }, _toDisplayString(row.filePath || "-"), 9, _hoisted_68),
                            _createElementVNode("td", _hoisted_69, [
                              _createTextVNode(_toDisplayString(row.exportTime?.replace("T", " ").slice(0, 19)) + " ", 1),
                              (row.archiveTime)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(_toDisplayString(row.archiveTime?.replace("T", " ").slice(0, 19)), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Files))
                      ]),
                      _: 1
                    }),
                    _cache[25] || (_cache[25] = _createElementVNode("div", null, "暂无登记记录，先执行一次归档任务", -1))
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})